import { useReveal } from "@/hooks/useReveal";

const BADGES = [
  {
    name: "Ecocert — USDA Organic",
    desc: "Organic certification for the United States market.",
  },
  {
    name: "Ecocert — EU Organic (EOS)",
    desc: "Organic certification for the European market.",
  },
  {
    name: "HACCP",
    desc: "Hazard analysis and critical control points programme.",
  },
  {
    name: "INVIMA (Colombian food authority)",
    desc: "Colombian national food and drug authority registration.",
  },
];

const DOWNLOADS = [
  "Technical data sheet — cane sugar",
  "Technical data sheet — cocoa powder",
  "Sample certificate of analysis",
];

export default function Certifications() {
  const ref = useReveal<HTMLDivElement>();

  return (
    <section className="bg-white py-20 md:py-28">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div ref={ref} className="reveal text-center">
          <h2 className="text-ink font-serif text-3xl md:text-4xl font-semibold">
            Verify us before you reply
          </h2>
          <p className="mt-3 text-ink/70 text-lg">
            Certificates and technical data sheets are available on request.
          </p>
        </div>

        <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {BADGES.map((badge) => (
            <div
              key={badge.name}
              className="bg-cream rounded-lg p-6 border border-cream-dark/60 flex flex-col"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-brand/10 text-brand">
                <i className="ri-shield-check-line text-2xl"></i>
              </div>
              <h3 className="mt-4 text-ink font-serif text-lg font-semibold">
                {badge.name}
              </h3>
              <p className="mt-2 text-ink/70 text-sm leading-relaxed">
                {badge.desc}
              </p>
              <span className="mt-4 inline-flex items-center gap-1.5 text-brand text-sm font-semibold">
                Available on request
              </span>
            </div>
          ))}
        </div>

        <div className="mt-8 flex flex-col sm:flex-row flex-wrap gap-3 justify-center">
          {DOWNLOADS.map((label) => (
            <span
              key={label}
              className="whitespace-nowrap inline-flex items-center gap-2 px-5 py-3 rounded-md border border-brown/50 text-ink text-sm font-semibold"
            >
              <i className="ri-file-download-line text-brown"></i>
              {label}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}